import {
  BadgeColor, ICON_ALERT_CIRCLE_OUTLINE, ICON_CHECK_CIRCLE_OUTLINE, ICON_PROGRESS_CHECK,
} from '@doveit/bricks';
import { ComputedJobApplicationStatus } from '../domain/types';

export const jobApplicationStatusLabels: Record<ComputedJobApplicationStatus, string> = {
  IN_PROGRESS: 'Da gestire',
  MANAGED: 'Gestita',
  ASSIGNED: 'Assegnata',
  INTERVIEW_SCHEDULED: 'Colloquio fissato',
  OFFER: 'Offerta',
  HIRED: 'Assunto',
  TALENT_POOL: 'Da risentire',
  KO_NOT_INTERESTED: 'Non interessato',
  KO_OFFER_REFUSED: 'Offerta rifiutata',
  KO_WRONG_NUMBER: 'Numero errato',
  KO_NOT_ELIGIBLE: 'Impresentabile',
  KO_DUPLICATE: 'Duplicata',
  KO_UNREACHABLE: 'Irraggiungibile',
  KO_TEST: 'Test',
};

export const jobApplicationStatusColors: Record<ComputedJobApplicationStatus, BadgeColor> = {
  IN_PROGRESS: 'warning',
  MANAGED: 'info',
  ASSIGNED: 'info',
  INTERVIEW_SCHEDULED: 'info',
  OFFER: 'info',
  HIRED: 'success',
  TALENT_POOL: 'critical',
  KO_NOT_INTERESTED: 'critical',
  KO_OFFER_REFUSED: 'critical',
  KO_WRONG_NUMBER: 'critical',
  KO_NOT_ELIGIBLE: 'critical',
  KO_DUPLICATE: 'critical',
  KO_UNREACHABLE: 'critical',
  KO_TEST: 'critical',
};

export const jobApplicationStatusActionIcon: Record<ComputedJobApplicationStatus, string> = {
  IN_PROGRESS: ICON_PROGRESS_CHECK,
  MANAGED: ICON_PROGRESS_CHECK,
  ASSIGNED: ICON_PROGRESS_CHECK,
  INTERVIEW_SCHEDULED: ICON_PROGRESS_CHECK,
  OFFER: ICON_PROGRESS_CHECK,
  HIRED: ICON_CHECK_CIRCLE_OUTLINE,
  TALENT_POOL: ICON_PROGRESS_CHECK,
  KO_NOT_INTERESTED: ICON_PROGRESS_CHECK,
  KO_OFFER_REFUSED: ICON_PROGRESS_CHECK,
  KO_WRONG_NUMBER: ICON_PROGRESS_CHECK,
  KO_NOT_ELIGIBLE: ICON_PROGRESS_CHECK,
  KO_DUPLICATE: ICON_ALERT_CIRCLE_OUTLINE,
  KO_UNREACHABLE: ICON_ALERT_CIRCLE_OUTLINE,
  KO_TEST: ICON_ALERT_CIRCLE_OUTLINE,
};
